<template>
  <div class="public-info-grid" :class="{compact, roundedStyle}">
    <component 
      v-if="title" 
      :is="titleTag"
      :class="{titleLeft}"
      class="mb-60 w-80 mx-auto" 
    >
      {{ title }}
    </component>
    <slot name="prepend" />
    <div class="public-info-grid-items">
      <public-info-grid-block v-for="item of items" :item="item" :rounded-style="roundedStyle" />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { PublicInfoGridItem } from '~/types/public'
import $breakpoints from '~~/composables/breakpoints'
import PublicInfoGridBlock from '~/components/public/public-info-grid-block.vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  items: {
    type: Array as PropType<PublicInfoGridItem[]>,
    default: () => []
  },
  compact: {
    type: Boolean,
    default: false
  },
  titleLeft: {
    type: Boolean,
    default: false
  },
  titleH3: {
    type: Boolean,
    default: false
  },
  roundedStyle: {
    type: Boolean,
    default: false
  }
})

const titleTag = computed(() => {
  return props.titleH3 ? 'h3' : 'h2'
})
</script>
